// 操作卓
// 監視→監視：UpdateScreen_Com
export function recvDataUpdateScreen(obj: any) {
  if (obj.cd !== "UpdateScreen_Com") {
    return null;
  }
  let data = {
    sr: obj.sr, // 送信元
    dt: obj.dt, // 送信先
    cmd: obj.st.cmd, // コマンド
    vid: obj.st.vid, // 車両ID
    prm: obj.st.prm, // メッセージID
    gi: obj.st.gi,
  };
  return data;
}

// 操作卓
// 車両→監視卓：PreAnnounce_EHJ_Com (発車前アナウンス指示)
export function recvDataSetDepartureAnnounce(obj: any) {
  if (obj.cd !== "PreAnnounce_EHJ_Com") {
    return null;
  }
  let data = {
    source: obj.sr, // 送信元
    destination: obj.dt, // 送信先
    control: obj.st.ctr, // 0:アナウンス指示なし、 1:アナウンス指示あり
  };
  return data;
}

// 1車両
// 車両→監視：CarDrive_Info
export function recvDataSetCarDrive(obj: any) {
  if (obj.cd !== "CarDrive_Info") {
    return null;
  }

  let data = {
    sr: obj.sr, // 送信元
    dt: obj.dt, // 送信先
    driveType: obj.st.md, // ドライブモード
    clm: obj.st.clm,
    vl: obj.st.vl, // 現在速度
    csh: obj.st.csh, // ヘッドライト状態
    stp: obj.st.stp, // ストップランプ状態
    ac: obj.st.ac, // アクセル踏み込み量
    brv: obj.st.brv, // ブレーキ踏み込み量
    str: obj.st.str, // ステアリング角
    srt_trq: obj.st.str_trq, // ステアリングトルク
    wrd: obj.st.wrd, // 誘導線検知
    tsp: obj.st.tsp, // 目標車速
    tsr: obj.st.tsr, // 目標ステアリング角
    bri: obj.st.bri, // ブレーキ指示
    ov_rid: obj.st.ov_rid, // 車両エラー状態
    dbtn: obj.st.dbtn, // 遠隔アシストボタン状態
  };
  return data;
}

// 1車両
// 車両→監視：VideoPat_Ret
export function recvDataSetVideoSelect(obj: any) {
  if (obj.cd !== "VideoPat_Ret") {
    return null;
  }
  if (
    !isKeyExists(obj.st, "video_patrq") &&
    !isKeyExists(obj.st, "video_patrt")
  ) {
    return null;
  }

  let data = {
    command: obj.cd, // コマンド種別
    source: obj.sr, // 送信元
    destination: obj.dt, // 送信先
    videoPat: obj.st.video_patrq, // 映像切り替え要請
    resetStatus: obj.st.video_patrt, // 映像切り替え結果
  };
  return data;
}

// 1車両
// 監視→車両：SelectCar_Ret
export function recvDataSelectCarRet(obj: any) {
  if (obj.cd !== "SelectCar_Ret") {
    return null;
  }
  let data = {
    source: obj.sr, // 送信元
    destination: obj.dt, // 送信先
    control: obj.st.ctr, // 制御状態
  };
  return data;
}

// 1車両
// 車両→監視：Int_Request
export function recvDataIntRequest(obj: any) {
  if (obj.cd !== "Int_Request") {
    return null;
  }
  let data = {
    source: obj.sr, // 送信元
    destination: obj.dt, // 送信先
    anst1: obj.st.anst1, // 確認要求フラグ
    anst2: obj.st.anst2, // 確認要求
  };
  return data;
}

function isKeyExists(obj: any, key: any) {
  if (obj[key] === undefined) {
    return false;
  } else {
    return true;
  }
}
